/**
 *
 * @author Patrik Harag
 * @version 2021-04-02
 */
export class TurtleContextScope {
    variables = new Map();
}